import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:          1000 * 60 * 2,   // 2 minutes
      gcTime:             1000 * 60 * 10,  // 10 minutes
      retry:              1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// ─── Query key factory ────────────────────────────────────────────────────────
// Centralized key registry to avoid typos and enable targeted invalidation

export const queryKeys = {
  dashboard: {
    all:     () => ["dashboard"] as const,
    metrics: () => ["dashboard", "metrics"] as const,
  },
  orders: {
    all:     () => ["orders"] as const,
    lists:   () => ["orders", "list"] as const,
    list:    (filters: Record<string, unknown>) => ["orders", "list", filters] as const,
    detail:  (id: number) => ["orders", "detail", id] as const,
  },
  inventory: {
    all:       () => ["inventory"] as const,
    products:  () => ["inventory", "products"] as const,
    product:   (id: number) => ["inventory", "product", id] as const,
    stock:     () => ["inventory", "stock"] as const,
    alertas:   () => ["inventory", "alertas"] as const,
    movements: (filters: Record<string, unknown>) => ["inventory", "movements", filters] as const,
  },
  expenses: {
    all:    () => ["expenses"] as const,
    lists:  () => ["expenses", "list"] as const,
    list:   (filters: Record<string, unknown>) => ["expenses", "list", filters] as const,
    detail: (id: number) => ["expenses", "detail", id] as const,
  },
  calendar: {
    all:    () => ["calendar"] as const,
    events: (filters: Record<string, unknown>) => ["calendar", "events", filters] as const,
    event:  (id: number) => ["calendar", "event", id] as const,
  },
  deleted: {
    all:   () => ["deleted"] as const,
    tabla: (tabla: string) => ["deleted", tabla] as const,
  },
} as const;
